export function getDeviceOptionsByType(devices: MediaDeviceInfo[], type: string) {
  return devices
    .filter((device) => device.kind === type)
    .map((device) => ({
      value: device.deviceId,
      label: device.label,
    }));
}
